const FiltersPlugin = {
    install: function(Vue, options) {
        Vue.filter('capitalize', function (value) {
            if (!value)
                return '';
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        });

        Vue.filter('toCurrency', function (value) {
            if (typeof value !== 'number') {
                return value;
            }
            var formatter = new Intl.NumberFormat('nl-NL', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2
            });
            return formatter.format(value);
        });

        // Convert YYYY-MM-DD to DD-MM-YYYY before display
        Vue.filter('formatDate', function (value) {
            if (value) {
                const dateElements = value.split('-');
                if (dateElements[2].length > 4) {
                    const date = dateElements[2].split(' ')[0];
                    let time = dateElements[2].split(' ')[1];
                    // Trim the secconds;
                    time = time.split(':').slice(0, -1).join(':');
                    dateElements[2] = date;
                    return dateElements.reverse().join('-') + ' ' + time;
                }
                return dateElements.reverse().join('-');
            }
            return value;
        });
    }
};

export default FiltersPlugin;



// WEBPACK FOOTER //
// ./src/plugins/FiltersPlugin.js